import axios from "axios";
import { SERVER } from "../../Constants";

const apiClient = axios.create({
    baseURL: SERVER + "/system-messages",
    withCredentials: true,
});

const userApiClient = axios.create({
    baseURL: SERVER,
    withCredentials: true,
});

// =============== TEMPLATE OPERATIONS ===============

// Get all templates
export const getAllTemplates = async () => {
    try {
        const response = await apiClient.get("/admin/templates");
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to fetch templates");
    }
};

// Get single template
export const getTemplateById = async (id) => {
    try {
        const response = await apiClient.get(`/admin/templates/${id}`);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to fetch template");
    }
};

// Create new template
export const createTemplate = async (templateData) => {
    try {
        const response = await apiClient.post("/admin/templates", templateData);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to create template");
    }
};

// Update template
export const updateTemplate = async (id, templateData) => {
    try {
        const response = await apiClient.put(`/admin/templates/${id}`, templateData);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to update template");
    }
};

// Delete template
export const deleteTemplate = async (id) => {
    try {
        const response = await apiClient.delete(`/admin/templates/${id}`);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to delete template");
    }
};

// Toggle template active status
export const toggleTemplate = async (id) => {
    try {
        const response = await apiClient.patch(`/admin/templates/${id}/toggle`);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to toggle template");
    }
};

// =============== MESSAGE OPERATIONS ===============

// Send message to users
export const sendMessage = async (messageData) => {
    try {
        const response = await apiClient.post("/admin/send", messageData);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to send message");
    }
};

// Broadcast message to all users
export const broadcastMessage = async (messageData) => {
    try {
        const response = await apiClient.post("/admin/broadcast", messageData);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to broadcast message");
    }
};

// =============== STATISTICS OPERATIONS ===============

// Get message statistics
export const getMessageStats = async () => {
    try {
        const response = await apiClient.get("/admin/stats");
        return response.data.stats;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to fetch statistics");
    }
};

// Get sent messages history
export const getSentMessages = async (filters = {}) => {
    try {
        const params = {};
        if (filters.limit) params.limit = filters.limit;
        if (filters.type) params.type = filters.type;
        if (filters.category) params.category = filters.category;
        if (filters.severity) params.severity = filters.severity;
        if (filters.isRead !== undefined) params.isRead = filters.isRead;
        if (filters.search) params.search = filters.search;
        if (filters.userId) params.userId = filters.userId;
        if (filters.startDate) params.startDate = filters.startDate;
        if (filters.endDate) params.endDate = filters.endDate;
        
        const response = await apiClient.get("/admin/messages", { params });
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.error || "Failed to fetch sent messages");
    }
};

// =============== USER SEARCH OPERATIONS ===============

// Search users (using same API as AllUsers component)
export const searchUsers = async (query) => {
    try {
        const params = {};
        if (query) params.search = query;
        const response = await userApiClient.get("/user/getUsers", { params });
        console.log("API response searchUsers:", response);
        return response.data;
    } catch (error) {
        console.error("API error:", error.response);
        throw new Error(error.response?.data?.message || "Failed to search users");
    }
};
